// extracted by mini-css-extract-plugin
module.exports = {"footer":"page-footer_footer__GSenq","logoContainer":"page-footer_logoContainer__GZx7n","logo":"page-footer_logo___L_Q6"};